module.exports = __webpack_public_path__ + "img/icon-dual.e73a5f9d.svg";